import { getUserStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type { PrioritizeRunSource } from '../store/schema/PriorityInboxStore';

// Sets the per-run join keys at the start of a Prioritize run. Reused (read-only) by
// downstream run events and cleared by clearPrioritizeRunContextMutator at terminal points.
export const setPrioritizeRunContextMutator: (
    mailboxInfo: MailboxInfo,
    runId: string,
    source: PrioritizeRunSource
) => void = mutatorAction(
    'setPrioritizeRunContextMutator',
    (mailboxInfo: MailboxInfo, runId: string, source: PrioritizeRunSource): void => {
        const store = getUserStore(mailboxInfo);
        store.prioritizeRunId = runId;
        store.prioritizeSource = source;
    }
);

// Clears the per-run join keys at terminal points (Stopped/Discarded/Failed/ViewClosed).
export const clearPrioritizeRunContextMutator: (mailboxInfo: MailboxInfo) => void = mutatorAction(
    'clearPrioritizeRunContextMutator',
    (mailboxInfo: MailboxInfo): void => {
        const store = getUserStore(mailboxInfo);
        store.prioritizeRunId = undefined;
        store.prioritizeSource = undefined;
    }
);
